var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qb-articles-status"},[_c('label',{staticClass:"text-lg text-orange"},[_vm._v("Article Status")]),_c('input-select',{attrs:{"selectedValue":_vm.queryArticleStatus,"options":_vm.articleStatusOptions,"multiple":true,"allowEmpty":false,"onChange":_vm.onChangeArticleStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }